import * as React from 'react';
export const thumbsUpSvg = React.forwardRef(function thumbsUpSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 2.329V4h2a2 2 0 0 1 2 2v.366a1 1 0 0 1-.035.263l-1.063 3.897A2 2 0 0 1 8.972 12H2a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h1.071l1.107-3.874C4.368.46 4.978 0 5.671 0A2.329 2.329 0 0 1 8 2.329ZM4.4 5.446l1.124-3.935a.153.153 0 0 1 .147-.111.93.93 0 0 1 .929.929V4A1.4 1.4 0 0 0 8 5.4h2a.6.6 0 0 1 .6.6v.313l-1.049 3.845a.6.6 0 0 1-.579.442H4.4V5.446ZM3 6.4H2a.6.6 0 0 0-.6.6v3a.6.6 0 0 0 .6.6h1V6.4Z',
    }),
  );
});
thumbsUpSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var thumbsUp = {
  category: 'icon',
  colorable: true,
  name: 'thumbsUp',
  svg: thumbsUpSvg,
};
